export const MessageCodes = {
    Internal: {
        SRC00: {key: 'B1', error_id: 'SRC-00'},
        TSRC001: {key: 'B1', error_id: 'T-SRC-01'},
        TSRCICS001: {key: 'B1', error_id: 'T-SRC-ICS-01'},
        ENCR001: {key: 'B2', error_id: 'ENCR-01'},
        ENCR002: {key: 'B2', error_id: 'ENCR-02'},
        ENCR003: {key: 'B2', error_id: 'ENCR-03'},
        ENCR004: {key: 'B2', error_id: 'ENCR-04'},
        ENCR00: {key: 'B2', error_id: 'ENCR-00'},
        EM001: {key: 'B3', error_id: 'EM-01'},
        EM000: {key: 'B3', error_id: 'EM-00'},
        CEC001: {key: 'B4', error_id: 'CEC-01'},
        CEC002: {key: 'B4', error_id: 'CEC-02'},
        CES001: {key: 'B5', error_id: 'T-CES-01'},
        TDSRL001: {key: 'B6', error_id: 'T-DSRL-01'},
        DSRL002: {key: 'B6', error_id: 'DSRL-02'},
        DSRL003: {key: 'B6', error_id: 'DSRL-03'},
        BM001: {key: 'B7', error_id: 'BM-01'},
        TBM002: {key: 'B7', error_id: 'T-BM-02'},
        TBM003: {key: 'B7', error_id: 'T-BM-03'},
        MSR001: {key: 'B8', error_id: 'T-MSR-01'},
        MSR002: {key: 'B8', error_id: 'T-MSR-02'},
        GR001: {key: 'B9', error_id: 'GR-01'},
        BSXY001: {key: 'B10', error_id: 'BSXY-01'},
        XCL001: {key: 'B11', error_id: 'XCL-01'},
        XCL002: {key: 'B11', error_id: 'T-XCL-02'},
        XCL003: {key: 'B11', error_id: 'XCL-03'},
        SKW000: {key: 'B12', error_id: 'SKW-00'},
        TSKW001: {key: 'B12', error_id: 'T-SKW-01'},
        TSKW002: {key: 'B12', error_id: 'T-SKW-02'},
        SKW003: {key: 'B12', error_id: 'SKW-03'},
        SKW004: {key: 'B12', error_id: 'SKW-04'},
        SKW005: {key: 'B12', error_id: 'SKW-05'},
        HYD000: {key: 'B13', error_id: 'HYD-00'},
        THYD001: {key: 'B13', error_id: 'T-HYD-01'},
        THYD002: {key: 'B13', error_id: 'T-HYD-02'},
        XS01: {key: 'B15', error_id: 'XS-01'},
        FCWSEL01: {key: 'B17', error_id: 'FC-WSEL-01'},
        FLWSEL01: {key: 'B20', error_id: 'FL-WSEL-01'},
        // TCESW001: {key: 'B23', error_id: 'T-CESW-01'},
        TXS01: {key: 'B26', error_id: 'T-XS-01'},
        XS02: {key: 'B26', error_id: 'XS-02'},
        XS03: {key: 'B26', error_id: 'XS-03'},
        XS04: {key: 'B26', error_id: 'XS-04'},
        SOF01: {key: 'B30', error_id: 'SOF-01'},
        B1_NOOUT01: {key: 'B1', error_id: 'NO-OUT-01'},
        B1_NOOUT02: {key: 'B1', error_id: 'NO-OUT-02'},
        B2_NOOUT01: {key: 'B2', error_id: 'NO-OUT-01'},
        B2_NOOUT02: {key: 'B2', error_id: 'NO-OUT-02'},
        B13_NOOUT01: {key: 'B13', error_id: 'NO-OUT-01'},
        B13_NOOUT02: {key: 'B13', error_id: 'NO-OUT-02'},
        B17_NOOUT01: {key: 'B17', error_id: 'NO-OUT-01'},
        B17_NOOUT02: {key: 'B17', error_id: 'NO-OUT-02'},
        B20_NOOUT01: {key: 'B20', error_id: 'NO-OUT-01'},
        B20_NOOUT02: {key: 'B20', error_id: 'NO-OUT-02'},
        B30_NOOUT01: {key: 'B30', error_id: 'NO-OUT-01'},
        B30_NOOUT02: {key: 'B30', error_id: 'NO-OUT-02'},
        B26_NOOUT01: {key: 'B26', error_id: 'NO-OUT-01'},
        B26_NOOUT02: {key: 'B26', error_id: 'NO-OUT-02'},
    },
    Compare: {
        NR001: {key: 'C1', error_id: 'NR-01'},
        NR002: {key: 'C1', error_id: 'NR-02'},
        NRICS001: {key: 'C1', error_id: 'NR-ICS-01'},
        NRICS002: {key: 'C1', error_id: 'NR-ICS-02'},
        SEC001: {key: 'C2', error_id: 'SEC-01'},
        SECICS001: {key: 'C2', error_id: 'SEC-ICS-01'},
        NC001: {key: 'C3', error_id: 'NC-01'},
        NC002: {key: 'C3', error_id: 'NC-02'},
        NC003: {key: 'C3', error_id: 'NC-03'},
        NC004: {key: 'C3', error_id: 'NC-04'},
        NC005: {key: 'C3', error_id: 'NC-05'},
        NC006: {key: 'C3', error_id: 'NC-06'},
        CD001: {key: 'C4', error_id: 'T-CD-01'},
        BMC001: {key: 'C5', error_id: 'BMC-01'},
        M006: {key: 'C6', error_id: 'T-M-01'},
        MICS006: {key: 'C6', error_id: 'T-M-ICS-01'},
        ES000: {key: 'C7', error_id: 'ES-00'},
        ES001: {key: 'C7', error_id: 'T-ES-01'},
        TTOPW001: {key: 'C7', error_id: 'T-TopW-01'},
        GRC001: {key: 'C8', error_id: 'GRC-01'},
        RXY001: {key: 'C9', error_id: 'RXY-01'},
        TFLW001: {key: 'C10', error_id: 'T-FLW-01'},
        TFLW002: {key: 'C10', error_id: 'T-FLW-02'},
        FLW003: {key: 'C10', error_id: 'FLW-03'},
        FLW004: {key: 'C10', error_id: 'FLW-04'},
        FLW005: {key: 'C10', error_id: 'FLW-05'},
        FLW006: {key: 'C10', error_id: 'FLW-06'},
        FLW000: {key: 'C10', error_id: 'FLW-00'},
        WSEL001: {key: 'C11', error_id: 'T-WSEL-01'},
        TWSEL000: {key: 'C11', error_id: 'T-WSEL-00'},
        WSEL00: {key: 'C11', error_id: 'WSEL-00'},
        WSELICS001: {key: 'C11', error_id: 'T-WSEL-ICS-01'},
        CEC001: {key: 'C12', error_id: 'T-CECC-01'},
        TIEFF001: {key: 'C13', error_id: 'T-IEFF-01'},
        TDSRC001: {key: 'C20', error_id: 'T-DSRC-01'},
        TOBST001: {key: 'C21', error_id: 'T-OBST-01'},
        C11_NOOUT01: {key: 'C11', error_id: 'NO-OUT-01'},
        C11_NOOUT02: {key: 'C11', error_id: 'NO-OUT-02'},
    }
}